// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RptLFm9Yb3fgby {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: var(--ds-radius-small, 3px);
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.RptLFm9Yb3fgby:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.RptLFm9Yb3fgby:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.RptLFm9Yb3fgby:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.RptLFm9Yb3fgby[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.RptLFm9Yb3fgby.iEN7bGhnMDl7KL {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.RptLFm9Yb3fgby.iEN7bGhnMDl7KL:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.RptLFm9Yb3fgby.iEN7bGhnMDl7KL:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.RptLFm9Yb3fgby.sSNK05m47V9qEi {
  width: 100%;
}
.RptLFm9Yb3fgby::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.RptLFm9Yb3fgby[type='file'] {
  width: 240px;
}
.RptLFm9Yb3fgby[type='text'],
.RptLFm9Yb3fgby[type='email'],
.RptLFm9Yb3fgby[type='password'] {
  width: 100%;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
}
`, ""]);
// Exports
export var input = `RptLFm9Yb3fgby`;
var _1 = `iEN7bGhnMDl7KL`;
export { _1 as "input-error" };
export var full = `sSNK05m47V9qEi`;
export default ___CSS_LOADER_EXPORT___;
